import moment from "moment"
import { create } from "zustand"

const INITIAL_FILTER = {
  startAt: moment().startOf("month").toDate(),
  endAt: moment().toDate(),
  factories: [],
  product: [],
  uf: [],
  courrier: [],
}

export const useIndicadoresFiltrosStore = create(set => ({
  filtrosSelecionados: INITIAL_FILTER,
  setFiltro: (campo, valor) =>
    set(state => ({
      filtrosSelecionados: { ...state.filtrosSelecionados, [campo]: valor },
    })),
  limparFiltros: () => set({ filtrosSelecionados: INITIAL_FILTER }),
  fetchReports: false,
  setFetchReports: () =>
    set(state => ({
      fetchReports: !state.fetchReports,
    })),
}))
